export default __webpack_public_path__ + "images/card-logo-generic.d68d4044d5e5f7e0fe13ff42b50a707b.png";